import React from 'react';
import { FiTrendingUp, FiTrendingDown } from 'react-icons/fi';

const StatCard = ({ title, value, change, icon, color = '#3B82F6', trend = 'up' }) => {
  return (
    <>
      <style>{`
       .stat-card {
          background: #FFF;
          border-radius: 16px;
          padding: 24px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.06);
          transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
       .stat-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background: ${color};
        }
       .stat-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 40px rgba(59, 130, 246, 0.15);
        }
       .stat-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 16px;
        }
       .stat-icon {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #FFF;
        }
       .stat-change {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 13px;
          font-weight: 700;
          padding: 4px 10px;
          border-radius: 20px;
        }
       .stat-change.up {
          background: #D1FAE5;
          color: #065F46;
        }
       .stat-change.down {
          background: #FEE2E2;
          color: #991B1B;
        }
       .stat-value {
          font-size: 32px;
          font-weight: 800;
          color: #0F172A;
          margin: 0 0 4px 0;
        }
       .stat-title {
          font-size: 14px;
          color: #64748B;
          font-weight: 600;
        }
      `}</style>
      <div className="stat-card">
        <div className="stat-header">
          <div className="stat-icon" style={{ background: color }}>{icon}</div>
          <div className={`stat-change ${trend}`}>
            {trend === 'up'? <FiTrendingUp /> : <FiTrendingDown />}
            {change}
          </div>
        </div>
        <div className="stat-value">{value}</div>
        <div className="stat-title">{title}</div>
      </div>
    </>
  );
};

export default StatCard;